/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckPlanNameParams,
  CreatePlanRequest,
  EditWorkflowBody,
  GetPlanParams,
  GetWorkflowParams,
  GetWorkflowSummaryParams,
  ListPlansParams,
  ListWorkflowsParams,
  PlanListResponse,
  PlanNameCheckResponse,
  PlanRecord,
  ProblemDetails,
  PublishWorkflow200,
  ServiceListResponse,
  WorkflowDetail,
  WorkflowListResponse,
  WorkflowSummaryResponse
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Newest first (`created_at` descending).
 * @summary The tenant's plans
 */
export const listPlans = (
    params?: ListPlansParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<PlanListResponse>(
      {url: `/v1/plans`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPlansQueryKey = (params?: ListPlansParams,) => {
    return [
    `/v1/plans`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPlansQueryOptions = <TData = Awaited<ReturnType<typeof listPlans>>, TError = ProblemDetails>(params?: ListPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlansQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlans>>> = ({ signal }) => listPlans(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listPlans>>>
export type ListPlansQueryError = ProblemDetails


export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = ProblemDetails>(
 params: undefined |  ListPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = ProblemDetails>(
 params?: ListPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = ProblemDetails>(
 params?: ListPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tenant's plans
 */

export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = ProblemDetails>(
 params?: ListPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * One transaction writes the plan, its version 1 and a `PLAN_PUBLISHED` audit row.
 * @summary Create a plan (publishes version 1)
 */
export const createPlan = (
    createPlanRequest: CreatePlanRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<PlanRecord>(
      {url: `/v1/plans`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlanRequest, signal
    },
      options);
    }




export const getCreatePlanMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlan>>, TError,{data: CreatePlanRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlan>>, TError,{data: CreatePlanRequest}, TContext> => {

const mutationKey = ['createPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlan>>, {data: CreatePlanRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlanMutationResult = NonNullable<Awaited<ReturnType<typeof createPlan>>>
    export type CreatePlanMutationBody = CreatePlanRequest
    export type CreatePlanMutationError = ProblemDetails

    /**
 * @summary Create a plan (publishes version 1)
 */
export const useCreatePlan = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlan>>, TError,{data: CreatePlanRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPlan>>,
        TError,
        {data: CreatePlanRequest},
        TContext
      > => {
      return useMutation(getCreatePlanMutationOptions(options), queryClient);
    }
    /**
 * Compared trimmed and case-insensitively; a retired plan's name is taken.
 * @summary Whether a plan name is still free
 */
export const checkPlanName = (
    params: CheckPlanNameParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<PlanNameCheckResponse>(
      {url: `/v1/plans/name-check`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCheckPlanNameQueryKey = (params?: CheckPlanNameParams,) => {
    return [
    `/v1/plans/name-check`, ...(params ? [params] : [])
    ] as const;
    }


export const getCheckPlanNameQueryOptions = <TData = Awaited<ReturnType<typeof checkPlanName>>, TError = ProblemDetails>(params: CheckPlanNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPlanName>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckPlanNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkPlanName>>> = ({ signal }) => checkPlanName(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkPlanName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckPlanNameQueryResult = NonNullable<Awaited<ReturnType<typeof checkPlanName>>>
export type CheckPlanNameQueryError = ProblemDetails


export function useCheckPlanName<TData = Awaited<ReturnType<typeof checkPlanName>>, TError = ProblemDetails>(
 params: CheckPlanNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPlanName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkPlanName>>,
          TError,
          Awaited<ReturnType<typeof checkPlanName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckPlanName<TData = Awaited<ReturnType<typeof checkPlanName>>, TError = ProblemDetails>(
 params: CheckPlanNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPlanName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkPlanName>>,
          TError,
          Awaited<ReturnType<typeof checkPlanName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckPlanName<TData = Awaited<ReturnType<typeof checkPlanName>>, TError = ProblemDetails>(
 params: CheckPlanNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPlanName>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether a plan name is still free
 */

export function useCheckPlanName<TData = Awaited<ReturnType<typeof checkPlanName>>, TError = ProblemDetails>(
 params: CheckPlanNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPlanName>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckPlanNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary One plan, at its current or a named version
 */
export const getPlan = (
    planId: string,
    params?: GetPlanParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<PlanRecord>(
      {url: `/v1/plans/${planId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanQueryKey = (planId: string,
    params?: GetPlanParams,) => {
    return [
    `/v1/plans/${planId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanQueryOptions = <TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetails>(planId: string,
    params?: GetPlanParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanQueryKey(planId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlan>>> = ({ signal }) => getPlan(planId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: planId !== null && planId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getPlan>>>
export type GetPlanQueryError = ProblemDetails


export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetails>(
 planId: string,
    params: undefined |  GetPlanParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetails>(
 planId: string,
    params?: GetPlanParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetails>(
 planId: string,
    params?: GetPlanParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One plan, at its current or a named version
 */

export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetails>(
 planId: string,
    params?: GetPlanParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanQueryOptions(planId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Every service, ordered by code.
 * @summary The service catalog
 */
export const listServices = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ServiceListResponse>(
      {url: `/v1/services`, method: 'GET', signal
    },
      options);
    }




export const getListServicesQueryKey = () => {
    return [
    `/v1/services`
    ] as const;
    }


export const getListServicesQueryOptions = <TData = Awaited<ReturnType<typeof listServices>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServices>>> = ({ signal }) => listServices(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServicesQueryResult = NonNullable<Awaited<ReturnType<typeof listServices>>>
export type ListServicesQueryError = ProblemDetails


export function useListServices<TData = Awaited<ReturnType<typeof listServices>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServices>>,
          TError,
          Awaited<ReturnType<typeof listServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServices<TData = Awaited<ReturnType<typeof listServices>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServices>>,
          TError,
          Awaited<ReturnType<typeof listServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServices<TData = Awaited<ReturnType<typeof listServices>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The service catalog
 */

export function useListServices<TData = Awaited<ReturnType<typeof listServices>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServices>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListServicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * One page of workflows for the Workflows tab: each with its published versions newest first, its live enrolments across every version, and how many of those sit on an older version.
 * @summary The tenant's workflows (Workflows tab)
 */
export const listWorkflows = (
    params?: ListWorkflowsParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<WorkflowListResponse>(
      {url: `/v1/workflows`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListWorkflowsQueryKey = (params?: ListWorkflowsParams,) => {
    return [
    `/v1/workflows`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ProblemDetails>(params?: ListWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkflowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkflows>>> = ({ signal }) => listWorkflows(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkflows>>>
export type ListWorkflowsQueryError = ProblemDetails


export function useListWorkflows<TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ProblemDetails>(
 params: undefined |  ListWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkflows>>,
          TError,
          Awaited<ReturnType<typeof listWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkflows<TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ProblemDetails>(
 params?: ListWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkflows>>,
          TError,
          Awaited<ReturnType<typeof listWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkflows<TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ProblemDetails>(
 params?: ListWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tenant's workflows (Workflows tab)
 */

export function useListWorkflows<TData = Awaited<ReturnType<typeof listWorkflows>>, TError = ProblemDetails>(
 params?: ListWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Published workflows, live enrolments across every workflow, and versions in draft, each with its change and a daily trend (the dashboard tile shape).
 * @summary The Workflows tab's KPI cards
 */
export const getWorkflowSummary = (
    params?: GetWorkflowSummaryParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<WorkflowSummaryResponse>(
      {url: `/v1/workflows/summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkflowSummaryQueryKey = (params?: GetWorkflowSummaryParams,) => {
    return [
    `/v1/workflows/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkflowSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflowSummary>>, TError = ProblemDetails>(params?: GetWorkflowSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSummary>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowSummary>>> = ({ signal }) => getWorkflowSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflowSummary>>>
export type GetWorkflowSummaryQueryError = ProblemDetails


export function useGetWorkflowSummary<TData = Awaited<ReturnType<typeof getWorkflowSummary>>, TError = ProblemDetails>(
 params: undefined |  GetWorkflowSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowSummary>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowSummary<TData = Awaited<ReturnType<typeof getWorkflowSummary>>, TError = ProblemDetails>(
 params?: GetWorkflowSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowSummary>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowSummary<TData = Awaited<ReturnType<typeof getWorkflowSummary>>, TError = ProblemDetails>(
 params?: GetWorkflowSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSummary>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Workflows tab's KPI cards
 */

export function useGetWorkflowSummary<TData = Awaited<ReturnType<typeof getWorkflowSummary>>, TError = ProblemDetails>(
 params?: GetWorkflowSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowSummary>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Read from the workflow registry.
 * @summary One workflow, one version's stage tree, and its version history
 */
export const getWorkflow = (
    workflowId: string,
    params?: GetWorkflowParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<WorkflowDetail>(
      {url: `/v1/workflows/${workflowId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkflowQueryKey = (workflowId: string,
    params?: GetWorkflowParams,) => {
    return [
    `/v1/workflows/${workflowId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkflowQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflow>>, TError = ProblemDetails>(workflowId: string,
    params?: GetWorkflowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowQueryKey(workflowId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflow>>> = ({ signal }) => getWorkflow(workflowId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflow>>>
export type GetWorkflowQueryError = ProblemDetails


export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = ProblemDetails>(
 workflowId: string,
    params: undefined |  GetWorkflowParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getWorkflow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = ProblemDetails>(
 workflowId: string,
    params?: GetWorkflowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getWorkflow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = ProblemDetails>(
 workflowId: string,
    params?: GetWorkflowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One workflow, one version's stage tree, and its version history
 */

export function useGetWorkflow<TData = Awaited<ReturnType<typeof getWorkflow>>, TError = ProblemDetails>(
 workflowId: string,
    params?: GetWorkflowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowQueryOptions(workflowId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * FRM-59 field set and nothing else: the workflow's `name` and its `whitelist_ref` (one whitelist per workflow, held on the draft version — never per stage).
 * @summary Edit a workflow's open draft, narrow field set
 */
export const editWorkflow = (
    workflowId: string,
    editWorkflowBody: EditWorkflowBody,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/workflows/${workflowId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: editWorkflowBody, signal
    },
      options);
    }




export const getEditWorkflowMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editWorkflow>>, TError,{workflowId: string;data: EditWorkflowBody}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof editWorkflow>>, TError,{workflowId: string;data: EditWorkflowBody}, TContext> => {

const mutationKey = ['editWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editWorkflow>>, {workflowId: string;data: EditWorkflowBody}> = (props) => {
          const {workflowId,data} = props ?? {};

          return  editWorkflow(workflowId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof editWorkflow>>>
    export type EditWorkflowMutationBody = EditWorkflowBody
    export type EditWorkflowMutationError = ProblemDetails

    /**
 * @summary Edit a workflow's open draft, narrow field set
 */
export const useEditWorkflow = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editWorkflow>>, TError,{workflowId: string;data: EditWorkflowBody}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editWorkflow>>,
        TError,
        {workflowId: string;data: EditWorkflowBody},
        TContext
      > => {
      return useMutation(getEditWorkflowMutationOptions(options), queryClient);
    }
    /**
 * Flips the workflow's open draft DRAFT → PUBLISHED, stamps and audits it, once — a replay answers 200 with what already holds.
 * @summary Publish a workflow's draft (FRM-59)
 */
export const publishWorkflow = (
    workflowId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<PublishWorkflow200>(
      {url: `/v1/workflows/${workflowId}/publish`, method: 'POST', signal
    },
      options);
    }




export const getPublishWorkflowMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishWorkflow>>, TError,{workflowId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof publishWorkflow>>, TError,{workflowId: string}, TContext> => {

const mutationKey = ['publishWorkflow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishWorkflow>>, {workflowId: string}> = (props) => {
          const {workflowId} = props ?? {};

          return  publishWorkflow(workflowId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof publishWorkflow>>>

    export type PublishWorkflowMutationError = ProblemDetails

    /**
 * @summary Publish a workflow's draft (FRM-59)
 */
export const usePublishWorkflow = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishWorkflow>>, TError,{workflowId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishWorkflow>>,
        TError,
        {workflowId: string},
        TContext
      > => {
      return useMutation(getPublishWorkflowMutationOptions(options), queryClient);
    }
